import React from 'react'
import Title from '../layouts/Title'
import Card from './Card'
import { AiFillAppstore } from 'react-icons/ai'
import { SiAntdesign, SiProgress } from 'react-icons/si'
import { FaGlobe, FaMobile, FaBars } from 'react-icons/fa'

const Features = () => {
  return (
    <section id='features' className='w-full py-20  border-b-[1px] border-b-black'>
        <Title title="Features" des="What I Do"/>
        <div className='grid grid-cols-3 gap-20'>
            <Card
                title = "Business Strategy"
                des = "I bring creativity to business strategy, analyzing trends and opportunities to develop innovative and impactful solutions through vision marketing and entrepreneurship."
                icon={<FaBars/>}
            />
            <Card
                title = "Data Analyst"
                des = "As a data analyst, I use creativity and analytical skills to interpret complex data, uncover insights, and drive informed decision-making. I focus on transforming raw data into actionable strategies to solve business challenges and optimize performance."
                icon={<AiFillAppstore/>}
            />
            <Card
                title = "UX & UI"
                des = "In UX/UI design, I focus on creating intuitive and visually appealing user experiences. By understanding user needs and behaviors, I craft seamless interfaces that enhance usability and engagement, ensuring a smooth interaction with digital products."
                icon={<SiProgress/>}
            />
            <Card
                title = "Mobile App Developer"
                des = "As a mobile app developer specializing in React Native, I create user-friendly apps for iOS and Android, focusing on seamless, efficient, and engaging experiences."
                icon={<FaMobile/>} 
            />
            <Card
                title = "Artificial Intelligence"
                des = "AI creates systems that mimic human intelligence, including machine learning, computer visions, with applications in healthcare, finance."
                icon={<SiAntdesign/>}
            />
            
            <Card
                title = "Web App Developer"
                des = "As a web app developer specializing in React.js and Tailwind CSS, I create dynamic, responsive applications focused on seamless user experiences and efficient functionality."
                icon={<FaGlobe/>}
            />
        </div>
    </section>
  )
}

export default Features


// w-1/3 px-20 h-80 py-10 rounded-lg shadow-shadowOne flex items-center bg-gradient-to-r
//         from-bodyColor to-[#202327] group
//         hover:bg-gradient-to-b hover:from-black hover:to-[#1e2024] transition-colors duration-100